import React, { useContext, useEffect, useState } from "react";
// another components
import { ModalVisualizarDocumentos } from "../../../../components/Generales/ModalVisualizarDocumentos";
import { useGestionarPostulaciones } from "../../../../hooks/useGestionarPostulaciones";
// styled components
import { Col, Row, Table, Empty, Button, Popover } from "antd";
// models
import { PostulacionModel } from "../../../../models/PostulacionesModel/postulacion.model";
// icons
import { EyeOutlined, DownloadOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { openNotification } from "../../../../utils/Notifactions";
import { ModalAceptar } from "../../components/ModalAceptar";
import apiParticipantes from "../../../../api/Participantes/api-participantes";
import DocumentosService from "../../../../api/Documentos/api-documentos";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/reducers";
import apiNotificaciones from "../../../../api/Notificaciones/api-notificaciones";
import { TemplateContext } from "../../../../utils/template_context";
import { DownloadFile } from "../../../../utils/DownloadFile";
import apiConvocatorias from "../../../../api/Convocatorias/api-convocatorias";
import moment from "moment";
import getStorageUser from "../../../../middlewares/GetStorageUser"

interface IProps {
  postulacion: PostulacionModel;
  setPostulacion: any;
  allPostulaciones: Array<PostulacionModel>;
  setAllPostulaciones: any;
  descargarArchivo: any;
  lineasConvocatoria: any;
  isBeps?: boolean;
}

const coloresEstado: any = {
  "Sin Revisar": "black",
  Aceptado: "#00904C",
  Rechazado: "#DB2828",
  Subsanar: "#F28C02",
  Subsanado: "#6435C9",
};

export const InformacionPostulacionSubsanar: React.FC<IProps> = (
  props: IProps
) => {
  const participante = useSelector((state: RootState) => state.participantes);

  const [modalDocumento, setModalDocumento] = useState<boolean>(false);
  const [documento, setDocumento] = useState<string>("");
  const [nombredocumento, setNombreDocumento] = useState<string>("");
  const [tipodocumento, setTipodocumento] = useState<string>("");
  const [indexdocumento, setIndexDocumento] = useState<number>(0);
  const [evento, setEvento] = useState<any>({});
  const [datosdocumento, setDatosDocumento] = useState<any>({});
  const [user, setUser] = useState<any>({});
  const [aceptarmodaldocumento, setAceptarModalDocumento] =
    useState<boolean>(false);
  //   functions
  const getUser = async () => {
    try {
      const _user = getStorageUser()
      setUser(_user)
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUser();
  }, [])

  const AceptarModalDocumento = async () => {
    setAceptarModalDocumento(false);

    const obtenerFecha = () => {
      let fechaActual = new Date();
      let anio = fechaActual.getFullYear();
      let mes = ('0' + (fechaActual.getMonth() + 1)).slice(-2);
      let dia = ('0' + fechaActual.getDate()).slice(-2);
      let hora = ('0' + fechaActual.getHours()).slice(-2);
      let minutos = ('0' + fechaActual.getMinutes()).slice(-2);
      let fechaYHora = anio + '-' + mes + '-' + dia + ' ' + hora + ':' + minutos;
      return fechaYHora
    }

    const formData = new FormData();
    formData.append("archivo", evento.target.files[0]);
    let data = await DocumentosService.guardarArchivo(formData);
    let nuevosdocumentos = props.postulacion.documentos_administrativos.map(
      (doc: any, indexdoc: number) => {
        if (indexdocumento === indexdoc) {
          let anterior = doc.url_participante
          return {
            ...doc,
            url_anterior: anterior,
            url_participante: data.data,
            checksubsanable: false,
            checksubsanado: true,
            fecha_subsanado: obtenerFecha(),
            subsanado_por: `${user.nombres} ${user.apellidos}`
          };
        }
        return {
          ...doc,
        };
      }
    );
    await apiParticipantes.guardarDocumentosAdministrativosPostulacion(
      props.postulacion.id_postulacion,
      nuevosdocumentos
    );
    let estado = "Subsanado";
    let subsanar = nuevosdocumentos.filter((data: any) => data.checksubsanable);
    if (subsanar.length > 0) estado = "Subsanar";
    await apiParticipantes.cambiarEstadoPostulacion({
      id_postulacion: props.postulacion.id_postulacion,
      estado: estado,
    });
    props.setPostulacion({
      ...props.postulacion,
      documentos_administrativos: nuevosdocumentos,
    });
    let newallpostulaciones = props.allPostulaciones.map((post: any) => {
      if (props.postulacion.id_postulacion === post.id_postulacion) {
        return {
          ...post,
          estado,
          documentos_administrativos: nuevosdocumentos,
        };
      }
      return {
        ...post,
      };
    });

    let payloadNotificacionAdmin = {
      tipo_notificacion: "Subsanación",
      nombre_proyecto: props.postulacion.nombre_propuesta,
      remitente: participante.idParticipante,
      convocatoria_id: props.postulacion.convocatoria_id,
    };

    let notificacionCorreo = {
      tipo_participante: 1,
      tipo_notificacion: "Subsanación",
      id_postulacion: props.postulacion.id_postulacion,
      remitente: participante.idParticipante,
      convocatoria_id: props.postulacion.convocatoria_id,
    };

    await apiNotificaciones.enviarNotificacionAdministrador(
      payloadNotificacionAdmin
    );
    await apiNotificaciones.enviarNotificacion(notificacionCorreo);

    return props.setAllPostulaciones(newallpostulaciones);
  };
  const CancelarModalDocumento = () => {
    setAceptarModalDocumento(false);
  };
  const context = useContext(TemplateContext);
  // columns
  const columnasDocumentaciontecnicaModal: any = [
    {
      title: "No.",
      width: 40,
      render: (datos: any, datos2: any, index: number) => {
        return (
          <>
            <span>{index + 1}</span>
          </>
        );
      },
      fixed: context.device === "md" ? "left" : false,
    },
    {
      title: "Tipo de documento",
      width: 120,
      fixed: context.device === "md" ? "left" : false,
      render: (datos: any, record: any, index: number) => (
        <div className="row">
          <div className="col-12">
            {datos.tipo_documento || datos.descripcion}
          </div>
        </div>
      ),
    },
    {
      title: "Nombre del documento",
      width: 300,
      render: (datos: any, datos2: any, index: number) => {
        return (
          <>
            <span>{datos.url_participante}</span>
          </>
        );
      },
    },
    {
      title: (
        <div className="row">
          <div className="col-12 justify-content-center">Estado</div>
        </div>
      ),
      width: 100,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any, record: any, index: number) => {
        return (
          <>
            {datos.checkaceptartecnico !== undefined ? (
              <div className="row">
                <div className="col-12 justify-content-center">
                  {datos.checkaceptartecnico === true ? (
                    <span style={{ color: coloresEstado["Aceptado"] }}>
                      Aceptado
                    </span>
                  ) : (
                    <span style={{ color: coloresEstado["Rechazado"] }}>
                      Rechazado
                    </span>
                  )}
                </div>
              </div>
            ) : (
              <div className="justify-content-center">
                <span>Inscrito sin revisar</span>
              </div>
            )}
          </>
        );
      },
    },
    {
      title: (
        <>
          <div className="row">
            <div className="col-12 justify-content-center">Acciones</div>
          </div>
          <div className="row">
            <div className="col-6 justify-content-center">Ver</div>
            <div className="col-6 justify-content-center">Descargar</div>
          </div>
        </>
      ),
      width: 120,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any, record: any, index: number) => {
        if (datos.url_documento || datos.url_participante) {
          return (
            <>
              <div className="row">
                <div className="col-6 justify-content-center">
                  <EyeOutlined
                    onClick={() => {
                      setModalDocumento(true);
                      setDocumento(datos.url_participante);
                    }}
                  />
                </div>
                <div className="col-6 justify-content-center">
                  <DownloadOutlined
                    onClick={() =>
                      DownloadFile(datos.url_participante)
                    }
                  />
                </div>
              </div>
            </>
          );
        }
      },
    },
  ];
  //  columns table documentación técnica
  const columnasDocumentacionadministrativaModal: any = [
    {
      title: "No.",
      width: 40,
      render: (datos: any, datos2: any, index: number) => {
        return (
          <>
            <span>{index + 1}</span>
          </>
        );
      },
      fixed: context.device === "md" ? "left" : false,
    },
    {
      title: "Tipo de documento",
      width: 380,
      fixed: context.device === "md" ? "left" : false,
      render: (datos: any) => (
        <div className="row">
          <div className="col-12">{datos.descripcion}</div>
        </div>
      ),
    },
    {
      title: (
        <Row className="width-100">
          <Col span={24} className="justify-content-center">
            Info doc
          </Col>
        </Row>
      ),
      width: 100,
      render: (datos: any, record: any, index: number) => {
        return (
          <>
            <Row className="width-100">
              <Col span={24} className="justify-content-center">
                <Popover
                  title="Trazabilidad del documento"
                  content={
                    <div style={{fontSize: 'small'}}>
                      <p className="font-color-6435C9">Fecha subsanado: <span style={{fontWeight: 'bold'}}>{datos.fecha_subsanado}</span></p>
                      <p className="font-color-6435C9">Subsanado por: <span style={{fontWeight: 'bold'}}>{datos.subsanado_por}</span></p>
                      { datos.url_anterior && (
                        <p className="font-color-6435C9">Ver anterior: {' '}
                          <span style={{fontWeight: 'bold'}}>
                            <EyeOutlined
                            onClick={() => {
                            setModalDocumento(true);
                            setDocumento(datos.url_anterior);
                            }}/>
                          </span>
                        </p>)
                      }
                    </div>
                  }>
                  <InfoCircleOutlined/>
                </Popover>
              </Col>
            </Row>
          </>
        );
      },
    },
    {
      title: (
        <div className="row">
          <div className="col-12 justify-content-center">Estado</div>
        </div>
      ),
      width: 100,
      render: (datos: any, record: any, index: number) => {
        return (
          <>
            <div className="row">
              <div className="col-12 justify-content-center">
                {datos.checkaceptar ? (
                  <span style={{ color: coloresEstado["Aceptado"] }}>
                    Aceptado*
                  </span>
                ) : datos.checkcancelar ? (
                  <span style={{ color: coloresEstado["Rechazado"] }}>
                    Rechazado
                  </span>
                ) : datos.checksubsanable ? (
                  <span style={{ color: coloresEstado["Subsanar"] }}>
                    Subsanar
                  </span>
                ) : datos.checksubsanado ? (
                  <span style={{ color: coloresEstado["Subsanado"] }}>
                    Subsanado
                  </span>
                ) : (
                  <span style={{ color: coloresEstado["Sin Revisar"] }}>
                    Sin Revisar
                  </span>
                )}
              </div>
            </div>
          </>
        );
      },
    },
    {
      title: (
        <>
          <div className="row">
            <div className="col-12 justify-content-center">Acciones</div>
          </div>
          <div className="row">
            <div className="col-6 justify-content-center"></div>
            <div className="col-3 justify-content-center">Ver</div>
            <div className="col-3 justify-content-center">Descargar</div>
          </div>
        </>
      ),
      width: 220,
      render: (datos: any, record: any, index: number) => {
        return (
          <>
            <div className="row">
              <div className="col-6 justify-content-center">
                {datos.checksubsanable ? (
                  <div className="row">
                    <div className="col-12">
                    <Button
                        onClick={async () => {
                          let convocatoria = await apiConvocatorias.getConvocatoriaById(props.postulacion.convocatoria_id)
                          for(const element of convocatoria.data.fechas){
                            if(element.clave == "Plazo para subsanar documentos y presentar observaciones"){
                              let fechaActual = moment();

                              let cierreAct = new Date(element.valormax);
                              cierreAct.setHours(cierreAct.getHours() - 1);
                              let anioc = cierreAct.getFullYear();
                              let mesc = ('0' + (cierreAct.getMonth() + 1)).slice(-2);
                              let diac = ('0' + cierreAct.getDate()).slice(-2);
                              let horac = ('0' + cierreAct.getHours()).slice(-2);
                              let minutosc = ('0' + cierreAct.getMinutes()).slice(-2);
                              let fechaYHoraActualizada = anioc + '-' + mesc + '-' + diac + ' ' + horac + ':' + minutosc;

                              if(fechaActual.isBefore(moment(fechaYHoraActualizada)) && fechaActual.isAfter(moment(element.valormin))){
                                var inputs: HTMLElement =
                                  document.getElementsByClassName(
                                    "inputs-ref-subsanar-mis-postulaciones"
                                  )[index] as HTMLElement;
                                inputs.click();
                              }else{
                                return openNotification({
                                  titulo: "Error",
                                  descripcion: `Solo se permiten subsanar en las fechas estipuladas desde ${moment(element.valormin.substring(0, 10)).format("LL")}, hasta ${moment(element.valormax).subtract(1, 'hours').format("LLL")}`,
                                  placement: "bottomRight",
                                });
                              }
                            } 
                          }
                          }
                        }
                        className="no-margin button-azul-ghost font-family-Montserrat-Medium"
                      >
                        Subsanar documento
                      </Button>
                      <input
                        className="inputs-ref-subsanar-mis-postulaciones"
                        type="file"
                        hidden
                        onChange={async (e: any) => {
                          if (e.target.files!.length > 0) {
                            if (e.target.files[0].type === "application/pdf") {
                              const { name } = e.target.files![0];
                              setNombreDocumento(name);
                              setEvento(e);
                              setIndexDocumento(index);
                              return setAceptarModalDocumento(true);
                            }
                            return openNotification({
                              titulo: "Error",
                              descripcion: "Solo se permiten archivos PDF",
                              placement: "bottomRight",
                            });
                          }
                          e.target.value = "";
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="row">
                    <div className="col-12">
                      <Button
                        onClick={() => {
                          var inputs: HTMLElement =
                            document.getElementsByClassName(
                              "inputs-ref-subsanar-mis-postulaciones"
                            )[index] as HTMLElement;
                          inputs.click();
                          // return setIndexDocumento(index);
                        }}
                        className="no-margin button-azul-ghost font-family-Montserrat-Medium"
                        hidden
                      >
                        Subsanar documento
                      </Button>
                      <input
                        className="inputs-ref-subsanar-mis-postulaciones"
                        type="file"
                        hidden
                      />
                    </div>
                  </div>
                )}
              </div>
              <div
                className="col-3 justify-content-center"
                style={{ alignItems: "center" }}
              >
                <EyeOutlined
                  className="font-size-12px"
                  onClick={() => {
                    setModalDocumento(true);
                    setDocumento(datos.url_participante);
                  }}
                />
              </div>
              <div
                className="col-3 justify-content-center"
                style={{ alignItems: "center" }}
              >
                <DownloadOutlined
                  className="font-size-12px"
                  onClick={() => DownloadFile(datos.url_participante)}
                />
              </div>
            </div>
          </>
        );
      },
    },
  ];
  //   columns table enlaces
  const columnaslinksModal = [
    {
      title: "URL",
      width: 260,
      render: (datos: any, record: any, index: number) => {
        return (
          <div className="row">
            <div className="col-12">
              <a target="_blank" href={datos.url}>
                {datos.url}
              </a>
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <>
      <div
        className="row"
        style={{
          paddingRight: "16px",
          paddingLeft: "16px",
          paddingTop: "16px",
          paddingBottom: "16px",
        }}
      >
        <div
          className="col-6 col-md-3 font-size-12px font-family-Montserrat-SemiBold"
          style={{ paddingLeft: "16px" }}
        >
          Nombre representante
        </div> 
        <div className="col-6 col-md-9 font-size-12px font-family-Montserrat-Regular">
          {props.postulacion.nombre_participante} 
        </div>
        {props.isBeps ? null : (
          <>
            <div
              className="col-6 col-md-3 font-size-12px font-family-Montserrat-SemiBold"
              style={{ paddingLeft: "16px", background: "#F0F6FB" }}
            >
              Tipo de participante
            </div>
            <div
              className="col-6 col-md-9 font-size-12px font-family-Montserrat-Regular"
              style={{ background: "#F0F6FB" }}
            >
              {props.postulacion.tipo_participante === "1"
                ? "Persona Natural"
                : props.postulacion.tipo_participante === "2"
                ? "Persona Juridica"
                : props.postulacion.tipo_participante === "3"
                ? "Grupo Conformado"
                : null}
            </div>
            <div
              className="col-6 col-md-3 font-size-12px font-family-Montserrat-SemiBold"
              style={{ paddingLeft: "16px" }}
            >
              Línea
            </div>
            <div className="col-6 col-md-9 font-size-12px font-family-Montserrat-Regular">
              {props.postulacion.linea_convocatoria}
            </div>
            <div
              className="col-6 col-md-3 font-size-12px font-family-Montserrat-SemiBold"
              style={{ paddingLeft: "16px", background: "#F0F6FB" }}
            >
              Categorías
            </div>
            <div
              className="col-6 col-md-9 font-size-12px font-family-Montserrat-Regular"
              style={{ background: "#F0F6FB" }}
            >
              {props.postulacion.categoria_linea_convocatoria}
            </div>
            <div
              className="col-6 col-md-3 font-size-12px font-family-Montserrat-SemiBold"
              style={{ paddingLeft: "16px" }}
            >
              Observaciones
            </div>
            <div
              className="col-6 col-md-9 font-size-12px font-family-Montserrat-Regular"
            >
              {props.postulacion.observaciones}
            </div>
          </>
        )}
        {props.postulacion.documentos_tecnicos !== null &&
        props.postulacion.documentos_tecnicos.length > 0 ? (
          <div
            className="col-12 font-family-Montserrat-Regular font-size-13px"
            style={{ paddingTop: "16px", paddingBottom: "1%" }}
          >
            <label className="font-family-Montserrat-SemiBold">
              Documentos Técnicos
            </label>
            <Table
              style={{ borderTop: "1px solid #C4C4C4" }}
              pagination={false}
              columns={columnasDocumentaciontecnicaModal}
              locale={{
                emptyText: (
                  <Empty
                    description="No se han diligenciados datos para está sección"
                    style={{ padding: "50px" }}
                  />
                ),
              }}
              dataSource={props.postulacion.documentos_tecnicos}
            />
          </div>
        ) : null}
        {props.postulacion.documentos_administrativos !== null &&
        props.postulacion.documentos_administrativos.length > 0 ? (
          <div
            className="col-12 font-family-Montserrat-Regular font-size-13px"
            style={{ paddingTop: "16px", paddingBottom: "1%" }}
          >
            <label className="font-family-Montserrat-SemiBold">
              Documentos administrativos
            </label>
            <Table
              style={{ borderTop: "1px solid #C4C4C4" }}
              pagination={false}
              columns={columnasDocumentacionadministrativaModal}
              locale={{
                emptyText: (
                  <Empty
                    description="No se han diligenciados datos para está sección"
                    style={{ padding: "50px" }}
                  />
                ),
              }}
              dataSource={props.postulacion.documentos_administrativos}
            />
          </div>
        ) : null}
        {props.postulacion.links !== null ? (
          <div
            className="col-12 font-family-Montserrat-Regular font-size-13px"
            style={{ paddingTop: "16px", paddingBottom: "1%" }}
          >
            <label className="font-family-Montserrat-SemiBold">
              Enlaces del proyecto
            </label>
            <Table
              pagination={false}
              style={{ paddingTop: "16px" }}
              columns={columnaslinksModal}
              locale={{
                emptyText: (
                  <Empty
                    description="No se han diligenciados datos para está sección"
                    style={{ padding: "50px" }}
                  />
                ),
              }}
              dataSource={props.postulacion.links}
            />
          </div>
        ) : null}
      </div>
      <ModalVisualizarDocumentos
        visualizar={modalDocumento}
        setVisualizar={setModalDocumento}
        state={{ documento: documento }}
        tipo="participante"
      />
      <ModalAceptar
        modal={aceptarmodaldocumento}
        AceptarModal={AceptarModalDocumento}
        CancelarModal={CancelarModalDocumento}
        CancelarArchivo={CancelarModalDocumento}
        TipoDocumento={tipodocumento}
        NombreArchivo={nombredocumento}
      />
    </>
  );
};
